/**
 * 도메인별 api url config
 */

export const BASE_API_URL = `${process.env.VUE_APP_SERVER_URI}/iskal/api/`;

export const MEMBER_API = {
  members: "members",
  temporary: "members/temporary",
  admin: "members/admin",
  nonReviewer: "members/non-reviewer",
  member: (args) => `members/${args.idx}`,
  memberType: (args) => `members/member-type/${args.idx}`,
  deleteMember: (args) => `members/${args.idx}`,
  realDeleteMember: (args) => `members/real/${args.idx}`,
};

export const ACCOUNT_API = {
  payments: "payments",
  paymentsByMember: "payments/member",
  feeTypes: "fee-types",
  deleteFeeType: (args) => `fee-types/${args.idx}`,
  updateFeeType: (args) => `fee-types/${args.idx}`,
  confirmTosspayments: "tosspayments/confirm",
  orderTosspayments: "tosspayments/orders",
  createPaypalOrder: "paypal/orders",
  capturePaypalPayment: "paypal/capture",
};

export const POST_API = {
  posts: "posts",
  showPost: (args) => `posts/${args.idx}`,
  createPost: `posts`,
  updatePost: (args) => `posts/${args.idx}`,
  deletePost: (args) => `posts/${args.idx}`,
};

export const CONFERENCE_API = {
  conferences: "conferences",
  conferenceForSubmission: "conferences/submissions",
  createConference: "conferences",
  updateConference: (args) => `conferences/${args.idx}`,
  deleteConference: (args) => `conferences/${args.idx}`,
  showConference: (args) => `conferences/${args.idx}`,
};

export const CONSENT_API = {
  consentDocuments: "consent-documents",
};

export const PAPER_API = {
  papers: "papers",
  showPapers: "papers/list",
  pendingReview: "papers/pending-review",
  updatePaper: (args) => `papers/${args.idx}`,
  updatePaperStatus: (args) => `papers/status/${args.idx}`,
  deletePaper: (args) => `papers/${args.idx}`,
  showPaper: (args) => `papers/details/${args.idx}`,
};

export const AUTH_API = {
  socialLogin: "auth/social-login",
  socialSignup: "auth/social-signup",
  login: "auth/login",
  signup: "auth/signup",
  temporaryPassword: "auth/temporary-password",
  changePassword: "auth/change-password",
  signup: "auth/signup",
  refreshToken: "auth/refresh",
};

export const FINAL_REVIEW_API = {
  finalReview: "final-reviews",
  finalReviewByPaper: "final-reviews/paper",
  updateFinalReview: (args) => `final-reviews/${args.idx}`,
  deleteFinalReview: (args) => `final-reviews/${args.idx}`,
  showFinalReview: (args) => `final-reviews/${args.idx}`,
};

export const REVIEW_API = {
  review: "reviews/members",
  showReviewsByPaper: "reviews/paper",
  createReview: `reviews`,
  updateReview: (args) => `reviews/${args.idx}`,
  deleteReview: (args) => `reviews/${args.idx}`,
  showReview: (args) => `reviews/${args.idx}`,
  createReviewForResubmission: "reviews/resubmission",
};

export const REVIEWER_API = {
  reviewer: "reviewers",
  nonPagination: "reviewers/non-pagination",
  createReviewer: (args) => `reviewers/${args.idx}`,
  updateReviewer: (args) => `reviewers/${args.idx}`,
  deleteReviewer: (args) => `reviewers/${args.idx}`,
  showReviewer: (args) => `reviewers/${args.idx}`,
};

export const MAILTEMPLATE_API = {
  mailtemplate: "mail-templates",
  updateMailtemplate: (args) => `mail-templates/${args.idx}`,
  deleteMailtemplate: (args) => `mail-templates/${args.idx}`,
  showMailtemplate: (args) => `mail-templates/${args.idx}`,
};

export const HOMEPAGE_CONTENT_API = {
  homepageContent: "homepage-contents",
  createContent: "homepage-contents",
  updateContent: (args) => `homepage-contents/${args.idx}`,
  showContent: (args) => `homepage-contents/${args.idx}`,
};

export const SIGNATURE_API = {
  showSignature: (args) => `signatures/${args.idx}`,
  showSignatureByPaper: "signatures/paper",
};

export const AUTHOR_API = {
  author: "authors",
  createAuthor: "authors",
  updateAuthor: (args) => `authors/${args.idx}`,
  deleteAuthor: (args) => `authors/${args.idx}`,
  showPreviousAuthors: "authors/previous",
};

export const FILE_API = {
  deleteFile: "file/delete",
  fileDownload: "file/download",
  uploadFile: "file/upload",
};

export const ARCHIVE_API = {
  showAllByCateogory: "archives",
  createArchive: "archives",
  updateArchive: (args) => `archives/${args.idx}`,
  deleteArchive: (args) => `archives/${args.idx}`,
  showArchive: (args) => `archives/${args.idx}`,
};

export const GALLERY_API = {
  showGalleries: "galleries",
  createGallery: "galleries",
  updateGallery: (args) => `galleries/${args.idx}`,
  deleteGallery: (args) => `galleries/${args.idx}`,
  showGallery: (args) => `galleries/${args.idx}`,
};

export const JOURNAL_API = {
  journals: "journals",
  createJournal: "journals",
  updateJournal: (args) => `journals/${args.idx}`,
  updateJournalBackcover: (args) => `journals/${args.idx}/backcover`,
  updateJournalCover: (args) => `journals/${args.idx}/cover`,
  updateJournalFixedPages: (args) => `journals/${args.idx}/fixed-pages`,
  updateJournalInfoPage: (args) => `journals/${args.idx}/info-page`,
  updateJournalTitlePage: (args) => `journals/${args.idx}/title-page`,
  updateJournalInnerBack: (args) => `journals/${args.idx}/inner-back`,
  deleteJournal: (args) => `journals/${args.idx}`,
  showJournal: (args) => `journals/${args.idx}`,
  journalsForSubmissions: "journals/submissions",
  showJournalForAgreement: (args) => `journals/${args.idx}/agreement`,
  showJournalForPublish: `journals/publish`,
};

export const CONSENT_DOCUMENT_API = {
  consentDocuments: "consent-documents",
  createConsentDocument: "consent-documents",
  updateConsentDocument: (args) => `consent-documents/${args.idx}`,
  deleteConsentDocument: (args) => `consent-documents/${args.idx}`,
  showConsentDocument: (args) => `consent-documents/${args.idx}`,
};

export const CONSENT_DOCUMENT_TYPE_API = {
  consentDocumentTypes: "consent-document-types",
};

export const JOURNAL_TYPE_API = {
  journalTypes: "journal-types",
};

export const JOURNAL_CONTENT_API = {
  journalContents: "journal-contents",
  createJournalContent: "journal-contents",
  updateJournalContent: (args) => `journal-contents/${args.idx}`,
  updateJournalContentAcceptedStatus: (args) =>
    `journal-contents/${args.idx}/accepted`,
  updateJournalContentGroup: (args) => `journal-contents/${args.idx}/group`,
  deleteJournalContent: (args) => `journal-contents/${args.idx}`,
  showJournalContent: (args) => `journal-contents/${args.idx}`,
  showJournalContentsByCategory: "journal-contents/category",
  showAllNonGroupJournalContents: "journal-contents/non-group",
  showContentsByGroup: `journal-contents/group`,
  updateJournalContentOrder: "journal-contents/order",
  finalPublish: "journal-contents/publish",
  showJournalContentByJournalAndCategory: (args) =>
    `journals/${args.journal_idx}/journal-contents`,
};

export const JOURNAL_CONTENT_GROUP_API = {
  journalContentGroups: "journal-content-groups",
  createJournalContentGroup: "journal-content-groups",
  updateJournalContentGroup: (args) => `journal-content-groups/${args.idx}`,
  deleteJournalContentGroup: (args) => `journal-content-groups/${args.idx}`,
  showJournalContentGroup: (args) => `journal-content-groups/${args.idx}`,
  updateJournalContentGroupOrder: "journal-content-groups/order",
};

export const PAPER_COMMENT_API = {
  createPaperComment: "paper-comments",
  updatePaperComment: (args) => `paper-comments/${args.idx}`,
  deletePaperComment: (args) => `paper-comments/${args.idx}`,
  getPaperComments: "paper-comments",
};
